import React from "react";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import TooltipHLPure from "../tooltipHL/tooltipHL.pure";
import "./inputFileHL.css";

const InputFileHLPure = (props) => {
  const {
    labelActive, //True to use label and false to not show
    labelInputFile, //Label text to input
    messageBtn, //Text button
    flex, //True or false, true active class with display flex
    acceptFile, //Extension of the file that you are going to use, example "application/pdf", ".doc, .docx, application/msword"
    selectedFile, // True or false, did you select any file?
    selectedFileName, //Name file selected
    errorFile, //Error to select file, true or false
    handleFile, //Funtion to handle the file extension
    handleDeleteFile, //Function to delete the uploaded file
    tooltipShow, //True or false to show tooltip
    titleTooltip, //Title tooltip string
    positionTooltip, //Position tooltip (top, left, right, bottom) string
    descriptionTooltip, //Description tooltip string
    subContent, //More text to tooltip description
    restContent, //More text to tooltip description
    informationIcon, // Choose the information icon true or false to custom img
  } = props;
  const { t } = useTranslation();

  // const [selectedFile, setSelectedFile] = useState(null);
  // const [errorFile, setErrorFile] = useState(false);
  // const [selectedFileName, setSelectedFileName] = useState(false);
  // const [deletePfd, setDeletePfd] = useState(false);
  // const [selectedFileBase64, setSelectedFileBase64] = useState(false);

  //Funtion to check the pdf extension
  // const handleFile = async (e) => {
  //File extension .docx
  // let result = e.target.files[0].name.slice(-5);
  // if (result === ".docx" || result === ".DOCX") {
  //File extension .pdf
  //   let result = e.target.files[0].name.slice(-4);
  //   if (result === ".pdf" || result === ".PDF") {
  //     setSelectedFile(e.target.files[0]);
  //     setSelectedFileName(e.target.files[0].name);
  //     setErrorFile(false);
  //   } else {
  //     setSelectedFile(null);
  //     setErrorFile(true);
  //     // setSelectedFileBase64("")
  //     return false;
  //   }
  // };

  //Function to delete the uploaded file
  // const handleDeleteFile = (e) => {
  //   setSelectedFile(null);
  //   setErrorFile(false);
  //   // setDeletePfd(true)
  //   // setSelectedFileBase64("")
  //   return true;
  // };

  return (
    <Grid
      lg={12}
      md={12}
      sm={12}
      es={12}
      className="inputFileHLPure-container-all"
    >
      {labelActive === true ? (
        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
          className="inputFileHLPure-container-text"
        >
          <label className="inputFileHLPure-label">{labelInputFile}</label>
          {tooltipShow ? (
            <TooltipHLPure
              positionTooltip={positionTooltip}
              titleTooltip={titleTooltip}
              descriptionTooltip={descriptionTooltip}
              subContent={subContent}
              restContent={restContent}
              informationIcon={informationIcon}
            />
          ) : (
            ""
          )}
        </Grid>
      ) : (
        ""
      )}
      <Grid
        item
        xs={12}
        lg={12}
        md={12}
        sm={12}
        es={12}
        className={
          flex === true
            ? "inputFileHLPure-container-upload-flex"
            : "inputFileHLPure-container-upload"
        }
      >
        <Grid
          item
          xs={12}
          lg={6}
          md={6}
          sm={6}
          es={6}
          className={
            flex === true
              ? "inputFileHLPure-container-btn"
              : "inputFileHLPure-container-btnSpace"
          }
        >
          <div className="inputFileHLPure-style">
            <i className="inputFileHL-icon k-icon k-i-plus"></i>
            <input
              {...props}
              id="file"
              type="file"
              className="input-files"
              accept={acceptFile}
              onChange={(e) => {
                handleFile(e);
              }}
            />
            {messageBtn}
          </div>
          {labelActive === false ? (
            <Grid className="inputFileHLPure-containerTooltip">
              {tooltipShow ? (
                <TooltipHLPure
                  positionTooltip={positionTooltip}
                  titleTooltip={titleTooltip}
                  descriptionTooltip={descriptionTooltip}
                  subContent={subContent}
                  restContent={restContent}
                  informationIcon={informationIcon}
                />
              ) : (
                ""
              )}
            </Grid>
          ) : (
            ""
          )}
          <div
            onClick={handleDeleteFile}
            className="inputFileHLPure-icon-trash"
          >
            <i className="inputFileHL-icon-trash k-icon k-i-delete k-i-trash"></i>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          lg={6}
          md={6}
          sm={6}
          es={6}
          className={
            selectedFile
              ? "inputFileHLPure-document-name-containerFlex"
              : "inputFileHLPure-document-name-container"
          }
        >
          {/**Button name file */}
          <Grid item className="inputFileHLPure-file-leyend">
            {/* <div className="inputFileHLPure-leyend-name"> */}
            {!selectedFile
              ? `${t("inputFileHLPure.notuploadDocument")}`
              : `${selectedFileName}`}
            {/* </div> */}
          </Grid>
          {selectedFile ? (
            <span className="inputFileHLPure-leyend-icon">
              <i className="k-icon k-i-check-circle k-i-checkmark-circle inputFileHLPure-icon "></i>
            </span>
          ) : null}
          {errorFile && (
            <span className="inputFileHLPure-message-error">
              {t("inputFileHLPure.extentionPDFNotValid")}
            </span>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export { InputFileHLPure as default };
